import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
	selector: 'app-finance-product-capture-deposit-amount',
	standalone: false,
	templateUrl: './finance-product-capture-deposit-amount.component.html',
	styleUrl: './finance-product-capture-deposit-amount.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class FinanceProductCaptureDepositAmountComponent {
	form = new FormGroup({
		amount: new FormControl<number | null>(null, [
			Validators.required,
			Validators.min(0.01)
		])
	});

	constructor(private modalRef: NzModalRef) { }

	submit(): void {
		if (this.form.valid) {
			this.modalRef.close(this.form.value.amount);
		}
	}

	cancel(): void {
		this.modalRef.close(null);
	}
}
